import { ICommand, IDefineCommand } from 'core-ts-types';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { APUserModeConfig } from '../../user_mode_config/config/ap_user_mode_config';
import { IAPAPMarkAsMetStatusDatasource } from '../datasources/mark_as_met_status_datasource';
import { IMarkAsMetUnmetUrl } from '../stratgies/mark_as_met_unmet_url_strategy';

export type ILoadMarkAsMetListCommand = () => ICommand;

angular
  .module('capability-ng-academic-planner')
  .factory(
    'loadMarkAsMetListCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      ngAPNotificationDelegate: INotificationDelegate,
      markAsMetUnmetUrl: IMarkAsMetUnmetUrl,
      ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource,
      log: any
    ): ILoadMarkAsMetListCommand => {
      return defineCommandORM('loadMarkAsMetListCommand', (deferred) => {
        $http
          .get(`${markAsMetUnmetUrl()}_programslot_status/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAPMarkAsMetStatusDatasource.clear().write(data);
            deferred.resolve();
          })
          .catch((e) => {
            ngAPNotificationDelegate.error(`Unable to load mark as met statuses: ${e.data.detail}`);
            log.error(e);
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/commands/load_mark_as_met_list_command.ts